import React, { MouseEventHandler, useContext } from 'react';
import './DanSwitch.css';
import ReactSVG from 'react-svg';
import intl from 'react-intl-universal';
import classNames from 'classnames';
import { ThemeContext } from '../../store/ThemeProvider';
import { getPendantColor } from '../../utils/color';

// 理论上DanSwitch已经没有其他type可选了，所以相关代码就注释掉了
// css也可以精简了
interface IDanSwitch {
  // type: number;
  on: boolean;
  setSwitch: MouseEventHandler;
}

const DanSwitch = function(props: IDanSwitch) {
  const { on, setSwitch } = props;
  const { mainColor, h1Color, backgroundColor } = useContext(ThemeContext);
  const [pendantBgColor, pendantIconColor] = getPendantColor(backgroundColor);
  return (
    <div className="dan-switch ignore-move" onClick={setSwitch}>
      <ReactSVG
        src={
          on ? require('../../svg/dan.svg') : require('../../svg/dan-off.svg')
        }
        style={{
          color: pendantIconColor,
          backgroundColor: pendantBgColor
        }}
        className={classNames('dan-switch-svg', { on })}
      />
    </div>
  );
};

// class DanSwitch extends React.Component<IDanSwitch, any> {
//   // getOnImg = (type: number) => {
//   //   switch (type * 1) {
//   //     case 2:
//   //       return (
//   //         <img
//   //           src={require('../../assets/switch-on-3.png')}
//   //           alt=""
//   //           className="dan-switch-img"
//   //         />
//   //       );
//   //     default:
//   //       return (
//   //         <img
//   //           src={require('../../assets/switch-on-2.png')}
//   //           alt=""
//   //           className="dan-switch-img"
//   //         />
//   //       );
//   //   }
//   // };
//   // getOffImg = (type: number) => {
//   //   switch (type * 1) {
//   //     case 2:
//   //       return (
//   //         <img
//   //           src={require('../../assets/switch-off-3.png')}
//   //           alt=""
//   //           className="dan-switch-img"
//   //         />
//   //       );
//   //     default:
//   //       return (
//   //         <img
//   //           src={require('../../assets/switch-off-2.png')}
//   //           alt=""
//   //           className="dan-switch-img"
//   //         />
//   //       );
//   //   }
//   // };
//   getImg = () => {
//     const { on } = this.props;
//
//     return <ReactSVG src={require('../../svg/dan.svg')} className={classNames('dan-switch-svg', {on})}/>;
//
//
//     //return this.props.on ? this.getOnImg(type) : this.getOffImg(type);
//   };
//   // getWord = () => {
//   //   return (
//   //     <div className={'dan-switch-word ' + (this.props.on ? 'on' : '')}>
//   //       {this.props.on ? intl.get('DanmakuOn') : intl.get('DanmakuOff')}
//   //     </div>
//   //   );
//   // };
//   render() {
//     return (
//       <div className="dan-switch ignore-move" onClick={this.props.setSwitch}>
//         {this.getImg()}
//       </div>
//     );
//   }
// }
export default DanSwitch;
